import React from 'react'
import classNames from 'classnames';
import PropTypes from 'prop-types';

//================ Property Value Type =====================
const propType={
  children:PropTypes.node,
  className:PropTypes.string,
  right:PropTypes.bool,
  isOnline:PropTypes.bool
}

//================ Default Property Value =====================
const defaultProps={
  right:false,
  isOnline:false
}



const ShortMessage = (props) => {
 
  const _props = props,
        ltrDirection={ direction:'ltr' },
        className=classNames("m-0 py-3",_props.className),
        avatarSide=classNames("avatar py-3 pb-5 ml-3",_props.right?"float-left":"float-right");

  return (
    <div className={className} style={_props.right?null:ltrDirection}>
      <div className={avatarSide}>
        <img src={_props.Avatar} className="img-avatar" alt={_props.From} />
        {_props.isOnline?<span className="avatar-status badge-success"></span>:null}
      </div>
      <div>
        <strong className='mt-1 ml-5'>{_props.From}</strong>
        <small title='2019/07/15'>{_props.Date}</small>
      </div>
      <small >{_props.Title}</small>
    </div>
  )
}

ShortMessage.propTypes=propType;
ShortMessage.defaultProps=defaultProps;

export default ShortMessage;